export default __webpack_public_path__ + "07d7a870c3fb247487077f8ff3e02a8b.png";